import { DataState } from 'types/store/reducers/dataSources';
import { AddressActions } from 'types/store/actions/addresses';
import { AddressActionTypes } from 'types/store/actions/constants';
import { Address } from 'types';

export const initialState: DataState<Address> = {
  data: {},
};

export default (
  state = initialState,
  action: AddressActions
): DataState<Address> => {
  switch (action.type) {
    case AddressActionTypes.FETCH_SUCCESS: {
      const address = action.payload;
      const data = { [address.id]: address };
      return {
        ...state,
        data,
      };
    }
    default:
      return state;
  }
};
